export default "__VITE_ASSET__BTudS16g__"